import { store } from '../../store';
import { ActionTypes } from '../../constants/enums';

export const needsReview = () => {
  const {
    returnItems: { cartActions = [] } = {},
    returnSubmission: { returnProcessInfo: { return_status: returnStatus } = {} },
    claims: { enabled: claimsEnabled },
  } = store.getState();

  return [
    cartActions?.length > 0 && cartActions?.every((action) => action === ActionTypes.Claim),
    returnStatus === 'processing' && claimsEnabled,
  ].some(Boolean);
};
